const languages = [
  { label: 'English', value: 'en' },
  { label: 'French', value: 'fr' },
  { label: 'Spanish', value: 'es' },
  { label: 'German', value: 'de' },
  { label: 'Portuguese', value: 'pt' },
  { label: 'Italian', value: 'it' },
  { label: 'Dutch', value: 'nl' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Russian', value: 'ru' },
  { label: 'Swedish', value: 'sv' },
  { label: 'Norwegian', value: 'no' },
  { label: 'Finnish (Suomi)', value: 'fi' },
  { label: 'Danish', value: 'da' },
  { label: 'Arabic', value: 'ar' },
  { label: 'Indonesian', value: 'ind' },
  { label: 'Korean', value: 'ko' },
  { label: 'Chinese', value: 'chi' },
  { label: 'Hindi', value: 'hin' },
  { label: 'Bengali', value: 'ben' },
  { label: 'Nepali', value: 'nep' },
  { label: 'Tamil', value: 'tam' },
  { label: 'Mongolian', value: 'mon' },
  { label: 'Sinhala', value: 'sin' },
  { label: 'Urdu', value: 'urd' },
  { label: 'Swahili', value: 'sw' },
  { label: 'Malayalam', value: 'mal' },
  { label: 'Kannada', value: 'kan' },
  { label: 'Burmese', value: 'bur' },
  { label: 'Samoan', value: 'sam' },
  { label: 'Ukrainian', value: 'ukr' },
  { label: 'Marathi', value: 'mar' },
]

const ISOlanguages = []
languages.forEach((language) => {
  ISOlanguages.push(language.value.toUpperCase())
})

export { languages, ISOlanguages }
